__turbopack_context__.v({
  "img": "GallerySlideModalInner-module-scss-module__c2Kx6a__img",
  "imgNoCursor": "GallerySlideModalInner-module-scss-module__c2Kx6a__imgNoCursor",
  "imgWrapper": "GallerySlideModalInner-module-scss-module__c2Kx6a__imgWrapper",
});
